
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalKeller from "../../modals/modal_keller.tsx";
import ModalKellerFuture from "../../modals/modal_keller_future.tsx";
import { MASSNAHMEN_KELLER_OPTIONS_CURRENT_LABELS, MASSNAHMEN_KELLER_OPTIONS_NEW_LABELS } from "../../state/types.ts";

export default function MeasureWidgetKeller() {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties); //MUST EXIST FOR REACTIVITY TO WORK
  const keller = useStore((state)=>state.keller || "");
  const keller_future = useStore((state)=>state.keller_future || "");

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);

  if (keller == "" && keller_future == ""){
    return <></>;
  }

      const current = measure_lables[keller] || MASSNAHMEN_KELLER_OPTIONS_CURRENT_LABELS[keller] || "" ;
      const future = measure_lables[keller_future] || MASSNAHMEN_KELLER_OPTIONS_NEW_LABELS[keller_future] || "" ;
  return <Measure key={"measure-widget-keller"} label={"Keller"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalKellerFuture/>:<ModalKeller/>)}/>;
}
